import { createContext, useContext } from 'react';

export const AppDataContext = createContext({});

export const useAppData = () => useContext(AppDataContext);
